import React, { useState, useEffect } from 'react';
import { ControlLabel, FormGroup, FormControl } from 'react-bootstrap';
import TimeParser from './TimeParser';
import { useDirtyWarningContext, DirtyWarningInputProps } from '../DirtyWarning';

export interface TimePickerProps extends DirtyWarningInputProps {
    key?: string;
    name?: string;    
    label?: string;
    value?: string;
    placeholder?: string;
    className?: string;    
    disabled?: boolean; 
    readOnly?: boolean;   

    onChange?: (timeValue: string) => void;

    validationState?: () => 'success' | 'warning' | 'error' | null;
}

export const TimePicker: React.FC<TimePickerProps> = (props) => {
    const { disableDirtyTracking = false, key, label, value = "", onChange, validationState, ...timePickerProps} = props;
    const context = useDirtyWarningContext();

    const validationStateResult = validationState ? validationState() : null;

    // State
    const [inputValue, setInputValue] = useState(value);
    
    // Effect
    useEffect(() => {
        setInputValue(TimeParser.parse({input: value}) || "");                    
    }, [value]); 

    const handleChange = (e: React.FormEvent<FormControl>) => {        
        const target = e.target as HTMLInputElement;   
        const newValue = target.value;
        
        setInputValue(newValue);
    }

    const handleBlur = (e: React.FormEvent<FormControl>) => {
        const target = e.target as HTMLInputElement;        
        const formattedValue = TimeParser.parse({input: target.value}) || "";

        setInputValue(formattedValue);

        if (onChange) {
            onChange(formattedValue);
        }

        if (!disableDirtyTracking) {
            context.setDirty(true);
        }
    }    

    const timePicker = 
        <FormControl    
            {...timePickerProps}              
            name={props.name}                    
            onChange={handleChange}
            onBlur={handleBlur}        
            value={inputValue}
            >
            {props.children}
        </FormControl>

    if (label === null) {
        return timePicker;
    }

    return (
        <FormGroup controlId={key} validationState={validationStateResult}>
            <ControlLabel>{label}</ControlLabel>            
            {timePicker}            
        </FormGroup>
    )
}

(TimePicker as any).displayName = 'TimePicker';
